import React from "react";
import PropTypes from "prop-types";

const ActionCell = ({
  onSubmit,
  onCancel,
  disabled,
  submitLabel = "Submit",
  cancelLabel = "Cancel"
}) => (
  <td className="text-center">
    <button
      type="button"
      className={`link-text small-text ${disabled ? "disabled" : ""}`}
      onClick={onSubmit}
      disabled={disabled}
      aria-label={submitLabel}
    >
      {submitLabel}
    </button>
    <button
      type="button"
      className="link-text small-text"
      onClick={onCancel}
      style={{ marginLeft: "16px" }}
      aria-label={cancelLabel}
    >
      {cancelLabel}
    </button>
  </td>
);

ActionCell.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  submitLabel: PropTypes.string,
  cancelLabel: PropTypes.string
};

ActionCell.defaultProps = {
  disabled: false,
  submitLabel: "Submit",
  cancelLabel: "Cancel"
};

export default ActionCell;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/cells/ActionCell.jsx